import { View } from 'react-native'
import styled from 'styled-components'
import { Button, useButtonHandlers } from '../../../elements/controls/index.js'
import Image from '../../../elements/images/Image/Image'
import { ImagePlaceholder } from '../../../elements/images/ImagePlaceholder/ImagePlaceholder'
import { ResponsiveImage } from '../../../elements/images/ResponsiveImage/ResponsiveImage.js'
import { H3, Paragraph } from '../../../elements/typography/index.js'
import { defaultTransforms } from '../../../services/cloudinary/index.js'
import { media, useMediaIs } from '../../../style/media.js'
import { LiveEventBadge, LiveEventBadgeWrapper } from '../LiveEventDetails/LiveEventBadge.js'
import messages from '../messages.js'

const calcHeight = (width) => width * 1.5

const Content = styled(View)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;

  margin-bottom: ${(props) => props.theme.spacing.medium}px;
`

const TitleLogo = styled(ResponsiveImage)`
  margin-bottom: ${(props) => props.theme.spacing.small}px;

  ${media.sm`
    margin-bottom: ${(props) => props.theme.spacing.smedium}px;
  `}
`

const Title = styled(H3)`
  text-align: center;
`

const Description = styled(Paragraph)`
  text-align: center;
  font-size: ${(props) => props.theme.fontSizes.xxxsmall}px;
  line-height: ${(props) => props.theme.fontSizes.xxxsmall * 1.3}px;
  padding: 0 ${(props) => props.theme.fontSizes.xsmall}px;

  ${media.sm`
    font-size: ${(props) => props.theme.fontSizes.small}px;
    line-height: ${(props) => props.theme.fontSizes.small * 1.3}px;
    padding: 0 ${(props) => props.theme.fontSizes.medium}px;
  `}
`

const bottomGradient = {
  background: '#121212',
  effect: `gradient_fade:15`,
  y: -0.4,
}

const transforms = [defaultTransforms, bottomGradient]

export const PortraitFeatured = ({ item, width: inputWidth, zoomed, onMouseMove, ...props }) => {
  const sm = useMediaIs('sm')
  const { handlers } = useButtonHandlers()

  if (inputWidth <= 0) {
    return null
  }

  // Default size within the carousel
  const width = Math.ceil(inputWidth)
  const height = Math.ceil(calcHeight(width))

  return (
    <ImagePlaceholder width={width} height={height}>
      <Image
        transforms={transforms}
        {...props}
        alt={item.title}
        width={width}
        height={height}
        publicId={item.portraitBg}
        scaledSize={zoomed ? false : { width, height }}
      />
      <LiveEventBadgeWrapper top>
        <LiveEventBadge status={item.status} />
      </LiveEventBadgeWrapper>

      <Content>
        <TitleLogo
          maxHeight={sm ? 80 : 50}
          aspectRatio={2.1}
          transforms={{ crop: 'pad', gravity: 'south' }}
          publicId={item.filmTitleImg}
        />
        <Title>{item.title}</Title>
        <Description>{item.shortDescription}</Description>
        <Button
          variant="white"
          fontStyle={{ color: 'black' }}
          icon="theaters"
          intlMsg={messages.viewDetails}
          onPress={() => handlers.viewDetails(item)}
          alignSelf="center"
        />
      </Content>
    </ImagePlaceholder>
  )
}

PortraitFeatured.calcHeight = calcHeight
